import { render, staticRenderFns } from "./collected.vue?vue&type=template&id=69279c56&scoped=true&"
import script from "./collected.vue?vue&type=script&lang=js&"
export * from "./collected.vue?vue&type=script&lang=js&"
import style0 from "./collected.vue?vue&type=style&index=0&id=69279c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69279c56",
  null
  
)

export default component.exports